import { Container } from "../../components/Container";
import { Cta } from "../../components/Cta";
import { DisplayHeading } from "../../components/DisplayHeading";
import { HERO } from "../../content/landing";
import { useScrollHero } from "../../lib/useScrollHero";
import { useAuth } from "../auth/context";
import { primaryCtaHref } from "../auth/destinations";
import styles from "./Hero.module.css";

/** Decorative only — no data, so violet is the right register (§01). */
const SPEEDLINE_WIDTHS = [220, 300, 170, 260, 200];

/**
 * The landing hero.
 *
 * It transforms on scroll: the speedlines accelerate off to the right, the hard
 * violet shadow under the headline collapses toward the type, and the whole
 * block lifts and fades as the reader leaves it. The idea is a car passing —
 * the speedlines are already the design system's motion device (§03), so this
 * gives them somewhere to go rather than inventing a new one.
 *
 * All of it is CSS driven by one custom property; see useScrollHero for why it
 * is written that way and why it stops dead under prefers-reduced-motion.
 */
export function Hero() {
  const { status } = useAuth();
  const ref = useScrollHero<HTMLElement>();

  return (
    <header className={styles.hero} ref={ref}>
      <div className={styles.speedlines} aria-hidden="true">
        {SPEEDLINE_WIDTHS.map((w, i) => (
          <span key={i} className={styles.speedline} style={{ width: w }} />
        ))}
      </div>

      <Container>
        <div className={styles.inner}>
          <p className={styles.tagline}>{HERO.tagline}</p>

          <DisplayHeading as="h1" size="xl" shadowed className={styles.headline}>
            {HERO.headline}
          </DisplayHeading>

          <p className={styles.sub}>{HERO.sub}</p>

          <div className={styles.actions}>
            {/* Signed in this goes to the product, not the price list. Sending
                a subscriber from "See the models" to /pricing quotes them a
                price for something they already pay for. */}
            <Cta to={primaryCtaHref(status)}>{HERO.ctaPrimary}</Cta>
            <Cta to="/why-kev#the-idea" variant="secondary">
              {HERO.ctaSecondary}
            </Cta>
          </div>
        </div>
      </Container>
    </header>
  );
}
